import {InboxButtonContainer} from "./InboxButton.styled";
import InboxIcon from '@mui/icons-material/Inbox';

export const InboxButton = ({ onClick }) => {
  return (
    <InboxButtonContainer onClick={onClick}>
      <InboxIcon sx={{ fontSize: 15 }} />
    </InboxButtonContainer>
  );  
};
